import { Square, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { MealCreditFormProvider } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditFormProvider/MealCreditFormProvider';
import { MealCreditDataProvider } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { AssignPeopleAndGroupsHeader } from 'src/components/oneCorp/features/MealCredit/components/Headers/AssignPeopleAndGroupsHeader';
import { DetailsHeader } from 'src/components/oneCorp/features/MealCredit/components/Headers/DetailsHeader';
import { MealCreditTitle } from 'src/components/oneCorp/features/MealCredit/components/Headers/MealCreditTitle';
import { MealCreditForm } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditForm';
import { AccordionStencil } from 'src/components/oneCorp/features/MealCredit/components/Stencils/AccordionStencil';
import { pushError, pushSuccess } from 'src/utilities/notifications';

export function MealCreditCreatePage(): JSX.Element {
  const { corpid: corpId } = useParams<{ corpid: string }>();
  const { push } = useHistory();

  return (
    <MealCreditFormProvider>
      <Stack y="lg" height="36px">
        <MealCreditTitle title="Add Meal credit" corpId={corpId} />
      </Stack>
      <Stack y="md">
        <DetailsHeader />
      </Stack>
      <Stack y="lg">
        <Square inset="lg" bg="globals.white" dimension="2">
          <MealCreditDataProvider>
            <MealCreditForm
              onAddMealCreditError={async (): Promise<void> => {
                pushError('Your meal credit was not added. Try again.');
              }}
              onAddMealCreditSuccess={async ({
                id,
              }: {
                id: string;
              }): Promise<void> => {
                pushSuccess('Your meal credit was added');
                push(
                  `/corporate/enterprise/${corpId}/meal-credits/${id}/details`
                );
              }}
            />
          </MealCreditDataProvider>
        </Square>
      </Stack>
      <Stack y="md">
        <AssignPeopleAndGroupsHeader />
      </Stack>
      <AccordionStencil />
    </MealCreditFormProvider>
  );
}
